import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-berekeningen-heffingskortingen',
  templateUrl: './heffingskortingen.component.html',
  styleUrls: ['./heffingskortingen.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule,
    SharedUiButtonModule,
    SharedUiDialogModule
  ]
})
export class HeffingskortingenBerekeningenComponent implements OnInit {

  @Input() public id!: string;
  @Input() formGroup!: FormGroup<{
    totaal: FormControl<number | null>;
    opbouw: FormGroup<{
      algemeneHeffingskorting: FormControl<number | null>;
      arbeidskorting: FormControl<number | null>;
      inkomensafhankelijkeCombinatieKorting: FormControl<number | null>;
      ouderenkorting: FormControl<number | null>;
      alleenstaandeOuderenkorting: FormControl<number | null>;
      wajong: FormControl<number | null>;
      grondslagGroeneBeleggingen: FormControl<number | null>;
      groeneBeleggingen: FormControl<number | null>;
      levensloopverlof: FormControl<number | null>;
      werkbonus: FormControl<number | null>;
      vutkorting: FormControl<number | null>;
      maximering: FormControl<number | null>;
      verhogingPartner: FormControl<number | null>
    }>
  }>
  public dialogVisible = false;

  ngOnInit() {
    // this.formgroup.reset({}, {emitEvent: false});
    // this.formgroup.patchValue(this.formGroup.value);
    // this.formgroup.disable();
  }

  showDialog() {
    this.dialogVisible = true;
  }

  propertyNamesToCheck: string[] = [
    'algemeneHeffingskorting',
    'arbeidskorting',
    'inkomensafhankelijkeCombinatieKorting',
    'ouderenkorting',
    'alleenstaandeOuderenkorting',
    'wajong',
    'groeneBeleggingen',
    'levensloopverlof',
    'werkbonus',
    'vutkorting',
    'maximering',
    'verhogingPartner',
  ];

  propertyTextMap: Record<string, string> = {
    algemeneHeffingskorting: 'Algemene heffingskorting',
    arbeidskorting: 'Arbeidskorting',
    inkomensafhankelijkeCombinatieKorting: 'Inkomensafhankelijke combinatiekorting',
    ouderenkorting: 'Ouderenkorting',
    alleenstaandeOuderenkorting: 'Alleenstaande ouderenkorting',
    wajong: 'Jonggehandicaptenkorting',
    groeneBeleggingen: 'Korting voor groene beleggingen',
    levensloopverlof: 'Levensloopverlofkorting',
    werkbonus: 'Werkbonus',
    vutkorting: 'Vut-korting',
    maximering: 'Af: Maximering',
    verhogingPartner: 'Verhoging i.v.m. inkomen partner',
  };

  getPropertyValue(propertyName: string): number {
    const control = this.formGroup.get(['opbouw', propertyName]);
    return control ? control.value : 0;
  }
}

